import {
    AbstractControl,
    ValidationErrors,
    ValidatorFn
} from '@angular/forms';
import {
    DatiqInputErrorTypes,
    IDatiqInput,
} from '@dat/datiq-components-pkg/utils';

export const geoIndeterminate: (settings: IDatiqInput) => ValidatorFn =
    (settings: IDatiqInput) =>
    (control: AbstractControl): ValidationErrors | null => {
        return control.value.pointId === null ||
            control.value.latitude === null ||
            control.value.longitude === null
            ? {
                  [DatiqInputErrorTypes.GeoPartial]: {
                      searchName: control.value.displayName ?? '',
                      key: settings.name,
                  },
              }
            : null;
    };
